import { type UseMutationResult, useMutation } from '@tanstack/react-query';

import { postJson } from '@/shared/api';

import { type UnsubscribeResult, unsubscribeResultSchema } from '../model/unsubscribe.schema';

/**
 * 광고성 정보 수신거부.
 *
 * **로그인을 요구하지 않는다.** 정보통신망법 제50조는 수신자가 간편하게 거부할 수 있어야
 * 한다고 정한다 — 계정을 찾아 로그인하게 만들면 그 조건을 못 지킨다. 대신 메일에 실어 보낸
 * 토큰으로 본인을 확인한다.
 */
export function useUnsubscribe(): UseMutationResult<UnsubscribeResult, Error, string> {
  return useMutation({
    // `/auth` 아래인 이유 — 운영 nginx 와 개발 프록시가 API 로 넘기는 접두사가 정해져 있다.
    //   `/api/...` 로 부르면 요청이 API 까지 못 가고 웹 화면(index.html)이 대신 답한다.
    mutationFn: (token: string) =>
      postJson('/auth/unsubscribe', { token }, unsubscribeResultSchema),
  });
}
